<h1 mat-dialog-title>{{ 'login.password_change' | translate }}</h1>

<div class="pwd-expired-dialog" [class.expired]="isPwdExpired" *ngIf="expiredDateStr">
  <span *ngIf="!isPwdExpired">{{ 'login.expiring_password' | translate : { date: expiredDateStr } }}</span>
  <span *ngIf="isPwdExpired">{{ 'login.expired_password' | translate : { date: expiredDateStr } }}</span>
</div>
<!-- FORM -->
<div class="mat-typography no-overflow" [formGroup]="form" class="d-flex flex-column gap-5">
  <!-- OLD PASSWORD -->
  <mat-form-field class="w-100" appearance="outline" *ngIf="this.form.controls.oldPassword">
    <mat-label>{{ 'login.old_password' | translate }}</mat-label>
    <input
      matInput
      [type]="formOldPasswordType"
      formControlName="oldPassword"
      [placeholder]="'login.old_password' | translate"
      id="formOldPw"
      required
      autocomplete="old-password"
    />
    <mat-error *ngIf="form.hasError('required', 'oldPassword')">
      {{ 'login.enter_old_password' | translate }}
    </mat-error>
    <button mat-icon-button matSuffix (click)="togglePasswordVisibility('oldPassword')" [attr.aria-label]="'Hide password'">
      <mat-icon class="color-icon">{{ formOldPasswordType == PASSWORD_TYPE ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </mat-form-field>
  <!-- NEW PASSWORD -->
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ 'login.new_password' | translate }}</mat-label>
    <input
      matInput
      [type]="formPwType"
      formControlName="password"
      [placeholder]="'login.new_password' | translate"
      id="formPw"
      required
      autocomplete="new-password"
    />
    <mat-error *ngIf="form.hasError('required', 'password')">
      {{ 'login.enter_password' | translate }}
    </mat-error>
    <mat-error *ngIf="form.get('password')?.hasError('sameOldPasswordError')">
      {{ 'login.same_old_password' | translate }}
    </mat-error>
    <mat-error *ngIf="form.get('password')?.hasError('invalidPassword')">
      {{ 'login.invalid_password' | translate }}
    </mat-error>
    <mat-icon style="margin-right: 2.5rem" matSuffix class="info color-icon" color="accent" [matTooltip]="'login.invalid_password' | translate"
      >info
    </mat-icon>
    <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" [attr.aria-label]="'Hide password'">
      <mat-icon class="color-icon">{{ formPwType == PASSWORD_TYPE ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </mat-form-field>
  <!-- CONFIRM PASSWORD -->
  <mat-form-field class="w-100" appearance="outline">
    <mat-label>{{ 'login.confirm_password' | translate }}</mat-label>
    <input matInput [type]="formPwType" formControlName="confirmPassword" [placeholder]="'login.confirm_password' | translate" id="confirmFormPw" />
    <mat-error *ngIf="form.hasError('required', 'confirmPassword')">
      {{ 'login.enter_confirm_password' | translate }}
    </mat-error>
    <mat-error *ngIf="form.get('confirmPassword')?.hasError('notSame')">
      {{ 'login.passwords_dont_match' | translate }}
    </mat-error>
    <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" [attr.aria-label]="'Hide password'">
      <mat-icon class="color-icon">{{ formPwType == PASSWORD_TYPE ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </mat-form-field>
</div>
<!-- FOOTER -->
<div class="d-flex justify-content-end gap-3 mt-4">
  <button *ngIf="!undisposableDialog" mat-flat-button mat-dialog-close>
    {{ 'common.close' | translate }}
  </button>
  <button *ngIf="undisposableDialog" mat-flat-button (click)="cancelForced()">
    {{ 'common.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="changePassword()">
    {{ 'common.update' | translate }}
  </button>
</div>
